import React from 'react';
import TextDisplay from '../../../Forms/TextDisplay/TextDisplay';
import './FormattedJsonViewer.css';
import FormattedArray from './FormattedArray';
import FormattedJsonDetails from '../FormattedJsonDetails/FormattedJsonDetails';

const FormattedJsonViewer = (props) => {

    let lineClass = "formattedjsonviewer-line";

    return (
        <div className="app-crafted-content">
            <div className='app-crafted-title'>{props.config.PageTitle}</div>
            <div className='app-crafted-headertext'>
                <TextDisplay text={props.config.Text}></TextDisplay>
            </div>
            <FormattedJsonDetails data={props.data}></FormattedJsonDetails>
        </div>
    );
};
  
export default FormattedJsonViewer;